import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createQuoteFromSite } from "store/siteRepo/actionCreator";
import { prcService, salesRepService, getJobDetailsService } from "services/priceQuote.service";
import { getProductsObject } from "utils/common";
import { showSpinner, hideSpinner } from "store/slices/spinner";
import InputField from "common/customInputField";
import Button from "react-bootstrap/Button";
import Modal from "common/modal";
import StoreLookup from "common/storeLookup";
import sortBy from "lodash/sortBy";
import { toast } from "react-toastify";
import { api } from "store/slices/api";

const SelectProducts = ({ siteData, selectedFloorPlansData, isShowProjectView }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.loggedInUser);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [projectsData, setProjectsData] = useState();
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [totalSelectableProducts, setTotalSelectableProducts] = useState(0);
  const [isShowCreateQuoteModal, setIsShowCreateQuoteModal] = useState(false);
  const [isValidStoreLookup, setIsValidStoreLookup] = useState(true);
  const [quoteName, setQuoteName] = useState("");

  const [defaultPrcObj, setDefaultPrcObj] = useState();
  const [defaultJobObj, setDefaultJobObj] = useState();
  const [cookieFields, setCookieFields] = useState({});
  const [defaultStoreData, setDefaultStoreData] = useState({});
  const { accountNumber } = siteData;
  const [quoteNameValid, setQuoteNameValid] = useState("");
  const [terrValid, setTerrValid] = useState("");
  const [salesNum, setSalesNum] = useState("");

  const [editQuote] = api.useDeprecatedEditQuoteMutation();

  useEffect(() => {
    setDefaultStoreData({
      storeNumber: currentUser.storeCcn,
      storeName: "",
      storePhoneNumber: "",
    });
    setCookieFields({
      storeNumber: currentUser.storeCcn,
      storeName: "",
      storePhoneNumber: "",
      territoryNumber: currentUser.terrCcn,
    });
  }, [currentUser.storeCcn, currentUser.terrCcn]);

  useEffect(() => {
    if (accountNumber) {
      salesRepService(accountNumber, "1")
        .then((salesRes) => {
          if (salesRes.terrCcn === "800100") {
            setSalesNum(`${currentUser?.firstname} ${currentUser?.lastname}`);
          } else {
            setSalesNum(`${salesRes?.firstName} ${salesRes?.lastName}`);
          }
        })
        .catch((err) => {
          console.error(err);
        });
      dispatch(showSpinner());
      getJobDetailsService(accountNumber)
        .then((result) => {
          if (result.length) {
            var defaultJobNumber = {};
            if (result.length > 1) {
              defaultJobNumber = result.reduce((previous, current) => {
                return current.jobNbr < previous.jobNbr ? current : previous;
              });
            } else {
              defaultJobNumber = result[0];
            }
            setDefaultJobObj(defaultJobNumber);
            prcService({
              acctNbr: accountNumber,
              jobNbr: defaultJobNumber.jobNbr,
            })
              .then((res) => {
                if (res.prcList.length > 1) {
                  const lowestPrc = res.prcList.reduce((previous, current) => {
                    return current.prcNbr < previous.prcNbr ? current : previous;
                  });
                  setDefaultPrcObj(lowestPrc);
                } else if (res.prcList.length === 1) {
                  setDefaultPrcObj(res.prcList[0]);
                } else {
                  setDefaultPrcObj({ jobNbr: "", jobName: "", prcNbr: "", descr: "" });
                }
              })
              .catch((err) => {
                console.error(err);
                setDefaultPrcObj({ jobNbr: "", jobName: "", prcNbr: "", descr: "" });
                dispatch(hideSpinner());
              });
          } else {
            setDefaultPrcObj({ jobNbr: "", jobName: "", prcNbr: "", descr: "" });
            setDefaultJobObj({ custId: "", jobName: "", jobNbr: "", terrCcn: "" });
          }
          dispatch(hideSpinner());
        })
        .catch((err) => {
          console.error(err);
          setDefaultPrcObj({ jobNbr: "", jobName: "", prcNbr: "", descr: "" });
          setDefaultJobObj({ custId: "", jobName: "", jobNbr: "", terrCcn: "" });
          dispatch(hideSpinner());
        });
    }
  }, [accountNumber]);

  useEffect(() => {
    const selectedFloorPlansDataClone = [...selectedFloorPlansData];
    const selectedIds = [];
    let totalProducts = 0;
    selectedFloorPlansDataClone?.map((layer) => {
      let productsObj = {};
      selectedIds.push(layer.projectId);
      const { productsObjUpdated, totalProductsUpdated } = getProductsObject(productsObj, totalProducts, layer.rooms);
      productsObj = productsObjUpdated;
      layer.productsData = productsObj;
    });

    let siteDataClone = JSON.parse(JSON.stringify(siteData));
    let projectArr = [];
    siteDataClone.projectDetailsList?.map((project) => {
      let temp = {};
      let layerArr = [];
      let finalProductArr = [];
      project.layerInfoList.map((layer) => {
        selectedFloorPlansDataClone.map((data) => {
          if (data.layerId === layer.layerId) {
            layerArr.push(data);
            Object.keys(data.productsData).map((productKey) => {
              const product = data.productsData[productKey];
              product["layerId"] = layer.layerId;
              product["productKey"] = productKey;
              finalProductArr.push(product);
            });
          }
        });
      });

      let tempObj = {};
      finalProductArr.map((product) => {
        if (!tempObj.hasOwnProperty(product.productKey)) {
          tempObj[product.productKey] = product;
        } else {
          tempObj[product.productKey].actualUsage =
            parseFloat(tempObj[product.productKey].actualUsage) + parseFloat(product.actualUsage);

          tempObj[product.productKey]?.siteLaborCodesData?.map((tempLabor) => {
            product.siteLaborCodesData?.map((labor) => {
              if (labor.laborCode === tempLabor.laborCode) {
                tempLabor.quantity = parseFloat(tempLabor.quantity) + parseFloat(labor.quantity);
              } else if (
                !tempObj[product.productKey].siteLaborCodes.includes(labor.laborCode) &&
                !tempObj[product.productKey].siteLaborCodesData.includes(labor)
              ) {
                tempObj[product.productKey].siteLaborCodesData.push(labor);
              }
            });
          });
        }
      });

      temp.finalProductArr = sortBy(Object.values(tempObj), [
        (p) => (p.rank === undefined ? 0 : Number(p.rank)),
        "productKey",
      ]);

      temp["projectId"] = project.projectId;
      temp["projectName"] = project.name;
      temp["layerId"] = !isShowProjectView ? project.layerInfoList[0].layerId : "";
      if (layerArr.length > 0) {
        projectArr.push(temp);
      }
    });

    const selectedProductsClone = [...selectedProducts];
    const selectedProjectsClone = [...selectedProjects];

    projectArr?.some((projectItem) => {
      projectItem.finalProductArr.map((prod) => {
        totalProducts += 1;
        const projectId = projectItem.projectId;
        if (!selectedProjectsClone.includes(projectId)) selectedProjectsClone.push(projectId);
        projectItem.isAnyProductSelected = true;
        if (
          !selectedProductsClone.includes(
            `${projectItem.projectId}-${prod.productKey.replaceAll(" ", "").replaceAll("-", "")}`,
          )
        ) {
          selectedProductsClone.push(
            `${projectItem.projectId}-${prod.productKey.replaceAll(" ", "").replaceAll("-", "")}`,
          );
        }
      });
    });
    setTotalSelectableProducts(totalProducts);

    selectedProducts?.map((productId, index) => {
      if (!selectedIds.includes(productId.substring(0, productId.lastIndexOf("-")))) {
        selectedProductsClone.splice(selectedProductsClone.indexOf(productId), 1);
      }
      return true;
    });

    setProjectsData(projectArr);
    setSelectedProjects(selectedProjectsClone);
    setSelectedProducts(selectedProductsClone);
  }, [selectedFloorPlansData]);

  const onProductSelection = (project, product) => {
    const productId = `${project.projectId}-${product.productKey.replaceAll(" ", "").replaceAll("-", "")}`;

    const projectsDataClone = [...projectsData];
    const selectedProductsClone = [...selectedProducts];
    const selectedProjectsClone = [...selectedProjects];

    if (selectedProducts.includes(productId)) {
      selectedProductsClone.splice(selectedProductsClone.indexOf(productId), 1);
      if (selectedProjectsClone.includes(productId.substring(0, productId.lastIndexOf("-")))) {
        selectedProjectsClone.splice(
          selectedProjectsClone.indexOf(productId.substring(0, productId.lastIndexOf("-"))),
          1,
        );
      }
    } else {
      selectedProductsClone.push(productId);
    }
    projectsDataClone?.some((projectItem, index) => {
      if (projectItem.projectId === project.projectId) {
        let isAnyProductSelected = false;
        projectItem.finalProductArr.map((product) => {
          if (
            selectedProductsClone.includes(
              `${project.projectId}-${product.productKey.replaceAll(" ", "").replaceAll("-", "")}`,
            )
          ) {
            isAnyProductSelected = true;
          }
        });
        projectsDataClone[index].isAnyProductSelected = isAnyProductSelected;
      }
      return projectItem.projectId === project.projectId;
    });

    setSelectedProducts(selectedProductsClone);
    setSelectedProjects(selectedProjectsClone);
    setProjectsData(projectsDataClone);
  };

  const onProjectSelection = (project) => {
    const projectsDataClone = [...projectsData];
    const selectedProjectsClone = [...selectedProjects];
    const selectedProductsClone = [...selectedProducts];

    const projectId = project.projectId;

    if (selectedProjects.includes(projectId)) {
      projectsData?.some((projectItem) => {
        if (projectItem.projectId === project.projectId) {
          projectItem.isAnyProductSelected = false;
        }
      });
      selectedProjectsClone.splice(selectedProjectsClone.indexOf(projectId), 1);
      selectedProducts?.map((product) => {
        if (product.substring(0, product.lastIndexOf("-")) === projectId) {
          selectedProductsClone.splice(selectedProductsClone.indexOf(product), 1);
        }
      });
    } else {
      selectedProjectsClone.push(projectId);
      projectsData?.some((projectItem) => {
        if (projectItem.projectId === project.projectId) {
          projectItem.isAnyProductSelected = true;
        }
        return projectItem.projectId === project.projectId;
      });
      if (project.finalProductArr?.length) {
        project.finalProductArr.map((product) => {
          if (
            !selectedProductsClone.includes(
              `${project.projectId}-${product.productKey.replaceAll(" ", "").replaceAll("-", "")}`,
            )
          ) {
            selectedProductsClone.push(
              `${project.projectId}-${product.productKey.replaceAll(" ", "").replaceAll("-", "")}`,
            );
          }
        });
      }
    }

    setSelectedProducts(selectedProductsClone);
    setSelectedProjects(selectedProjectsClone);
    setProjectsData(projectsDataClone);
  };

  const onCreateQuoteClick = (isShow) => {
    setIsShowCreateQuoteModal(isShow);
  };

  const handleCookieFieldsChange = (e) => {
    const { id, value } = e.target;
    setCookieFields({ ...cookieFields, [id]: value });
  };

  const handleQuoteNameChange = (e) => {
    const { id, value } = e.target;
    setQuoteName(value);
    if (value.length > 40) {
      setQuoteNameValid("Please enter maximum of 40 letters");
    } else if (value.length <= 40) {
      setQuoteNameValid("");
    }
  };

  const onStoreNumberChange = (strNum, data) => {
    setCookieFields({
      ...cookieFields,
      storeName: data.storeName,
      storeNumber: strNum,
      storePhoneNumber: data.storePhoneNumber,
    });
  };

  const onStoreNameChange = (strName, isValid, data) => {
    setCookieFields({
      ...cookieFields,
      storeName: data.storeName,
      storeNumber: data.storeNumber,
      storePhoneNumber: data.storePhoneNumber,
    });
  };

  const onStoreLookupValidation = (isValid) => {
    if (isValid !== isValidStoreLookup) {
      setIsValidStoreLookup(isValid);
    }
  };

  const confirmCreateQuote = async () => {
    const {
      accountNumber,
      accountName,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      accountCity,
      accountStreet,
      accountZip,
      accountState,
      siteId,
      laborTaxIndicator,
    } = siteData;
    const createQuoteObj = {
      quoteName,
      accountNumber,
      accountName,
      storeNumber: cookieFields.storeNumber,
      storeName: cookieFields.storeName,
      createdBy: currentUser.sub,
      territory: cookieFields.territoryNumber,
      siteId,
      parentNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      phoneNumber,
      laborTaxIndicator: laborTaxIndicator === "1" ? true : false,
      customerName,
      storePhone: cookieFields.storePhoneNumber,
      city: accountCity,
      street: accountStreet,
      zip: accountZip,
      state: accountState,
      quoteFloorDetails: projectsData
        ?.filter((project) => {
          return project.isAnyProductSelected;
        })
        .map((selectedProject) => {
          let layerObj = {
            floorId: "",
            layerId: selectedProject.layerId,
            floorName: selectedProject.projectName,
            quoteProductDetails: [],
            quoteLaborCodeDetails: [],
          };
          const floorLaborCodes = {};

          if (selectedProject.finalProductArr?.length) {
            selectedProject.finalProductArr.map((product) => {
              if (
                selectedProducts.includes(
                  `${selectedProject.projectId}-${product.productKey.replaceAll(" ", "").replaceAll("-", "")}`,
                )
              ) {
                layerObj.quoteProductDetails.push({
                  productId: "",
                  floorId: "",
                  productName: product.productKey,
                  category: product.type,
                  categoryCode: product.categoryCode,
                  quantity: product.modActualUsage
                    ? product.modActualUsage
                    : product.actualUsage
                      ? parseFloat(product.actualUsage)
                      : 0,
                  salesNumber: product.salesNumber,
                  rank: layerObj.quoteProductDetails.length + 1,
                });

                product.siteLaborCodesData?.map((laborCodeItem) => {
                  if (floorLaborCodes[laborCodeItem.laborCode] === undefined) {
                    floorLaborCodes[laborCodeItem.laborCode] = {
                      createdBy: laborCodeItem.createdBy,
                      createdTimestamp: laborCodeItem.createdTimestamp,
                      laborCode: laborCodeItem.laborCode,
                      laborCodeDesc: laborCodeItem.laborCodeModDesc
                        ? laborCodeItem.laborCodeModDesc
                        : laborCodeItem.laborCodeDesc,
                      laborCodeDescExt: laborCodeItem.laborCodeDescExt,
                      laborCodeId: laborCodeItem.laborCodeId,
                      quantity: laborCodeItem.quantity,
                      roomInfoId: laborCodeItem.roomInfoId,
                      siteLaborCodeId: laborCodeItem.siteLaborCodeId,
                      updatedBy: laborCodeItem.updatedBy,
                      updatedTimestamp: laborCodeItem.updatedTimestamp,
                      taxable: laborCodeItem.isTaxable,
                    };
                  } else {
                    floorLaborCodes[laborCodeItem.laborCode].quantity =
                      parseFloat(floorLaborCodes[laborCodeItem.laborCode].quantity) +
                      parseFloat(laborCodeItem.quantity);
                  }
                });
              }
            });
          }
          layerObj.quoteLaborCodeDetails = Object.values(floorLaborCodes);

          return layerObj;
        }),
    };

    let valid = true;
    setQuoteNameValid("");
    setTerrValid("");
    if (!quoteName || quoteName == "") {
      valid = false;
      setQuoteNameValid("Please enter Quote Name");
    }
    if (quoteName && quoteName.length > 40) {
      valid = false;
      setQuoteNameValid("Please enter maximum of 40 letters");
    } else if (!cookieFields.territoryNumber || cookieFields.territoryNumber == "") {
      valid = false;
      setTerrValid("Please enter Territory Number");
    }

    if (!valid || !isValidStoreLookup) {
      return;
    }

    const createQuotePromise = async () => {
      const res = await dispatch(createQuoteFromSite(createQuoteObj));
      if (res.accountNumber) {
        let editPayload = {
          userName: currentUser.sub,
          quoteId: res.quoteId,
          quoteName: res.quoteName,
          territory: !res.territory ? "" : res.territory,
          expirationDate: "Upon 30 days notice",
          salesRep: !salesNum ? "" : salesNum,
          accountNumber: !res.accountNumber ? "" : res.accountNumber,
          accountName: !res.accountName ? "" : res.accountName,
          contactName: !res.contactName ? "" : res.contactName,
          phoneNumber: !res.phoneNumber ? "" : res.phoneNumber,
          customerName: !res.customerName ? "" : res.customerName,
          storeNumber: !res.storeNumber ? "" : res.storeNumber,
          storeName: !res.storeName ? "" : res.storeName,
          storePhoneNumber: !res.storePhone ? "" : res.storePhone,
          parentNumber: !res.parentNumber ? "" : res.parentNumber,
          parentName: !res.parentName ? "" : res.parentName,
          execName: !res.execName ? "" : res.execName,
          execNumber: !res.execNumber ? "" : res.execNumber,
          taxRate: !res.taxRate ? "0.00" : res.taxRate,
          city: !res.city ? "" : res.city,
          street: !res.street ? "" : res.street,
          zip: !res.zip ? "" : res.zip,
          state: !res.state ? "" : res.state,
          jobNumber: defaultJobObj?.jobNbr,
          jobName: defaultJobObj?.jobName,
          prcNumber: defaultPrcObj?.prcNbr,
          prcDesc: defaultPrcObj?.descr,
          isTaxEdited: false,
          isPrcEdited: true,
          isStoreAccChanged: false,
          laborTaxIndicator: laborTaxIndicator === "1" ? true : false,
        };
        await editQuote(editPayload);
      }
      return res;
    };

    toast
      .promise(createQuotePromise(), {
        pending: "Creating Quote",
        success: "Successfully created quote.",
        error: "Something went wrong.",
      })
      .then((res) => navigate(`/priceQuote/${res.quoteId}#customer-details`))
      .catch(() => onCreateQuoteClick(false));
  };

  return (
    <>
      <div className="mt-5 mt-md-0 select-products d-flex flex-column justify-content-between">
        <div className="search-form-container px-0 border-0">
          <div className="search-form-container__fields">
            {projectsData?.map((project, index) => {
              return (
                <div className="select-products-layer-info d-flex flex-column" key={index}>
                  <div className="d-flex justify-content-between flex-grow-1 align-items-center select-products-layer-info-header">
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="select-all-products-checkbox"
                        onChange={(e) => onProjectSelection(project)}
                        checked={selectedProjects?.includes(project.projectId)}
                      />
                      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                        <span className="select-products-layer-info-title">{project.projectName}</span>
                      </div>
                    </div>
                  </div>
                  <div className="product-view">
                    <div className="col-12 accordion accordion-flush" id={`project-${project.projectId}`}>
                      {project.finalProductArr && project.finalProductArr?.length ? (
                        project.finalProductArr.map((product, index) => {
                          return (
                            <div className="accordion-item" key={index}>
                              <div className="product-name">
                                <span className="product-name-value d-flex align-items-center">
                                  <span>{product.productKey}</span>
                                </span>
                              </div>
                              <div className="accordion-row d-flex align-items-start flex-column">
                                <div className="d-flex align-items-start align-items-md-center flex-column flex-md-row w-100 product-attribute-container">
                                  <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute sales-number col-1 seperator">
                                    <span className="label"></span>
                                    <span>
                                      <input
                                        type="checkbox"
                                        className="product-checkbox"
                                        onChange={(e) => onProductSelection(project, product)}
                                        checked={selectedProducts?.includes(
                                          `${project.projectId}-${product.productKey
                                            .replaceAll(" ", "")
                                            .replaceAll("-", "")}`,
                                        )}
                                      />
                                    </span>
                                  </div>
                                  <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute sales-number col-1 seperator">
                                    <span className="label">SW Sales Number</span>
                                    <span>{product.salesNumber ? product.salesNumber : "NA"}</span>
                                  </div>
                                  <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute category col-2 seperator">
                                    <span className="label">SW Product Category</span>
                                    <span>{product.type ? product.type : "NA"}</span>
                                  </div>
                                  <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start product-attribute usage col-md-2 col-lg-auto">
                                    <span className="label">
                                      Actual Usage {product.unit ? `(${product.unit})` : ""}
                                    </span>
                                    <span>
                                      {product.modActualUsage
                                        ? product.modActualUsage.toFixed(2)
                                        : product.actualUsage || product.actualUsage == "0"
                                          ? product.actualUsage.toFixed(2)
                                          : "NA"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="d-flex w-100 align-items-center justify-content-center">
                          <div className="alert alert-warning no-rooms-info mt-4" role="alert">
                            No products available in this room. Consider adding one!
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="d-flex justify-content-between flex-column-reverse flex-md-row footer-actions">
          <Button
            variant="outline-primary"
            onClick={() => navigate(`/siteRepo/createQuote/${siteId}#select-floor-plans`)}
          >
            Back
          </Button>
          <Button className="m-0" variant="primary" onClick={() => onCreateQuoteClick(true)}>
            Create Quote
          </Button>
        </div>
        {isShowCreateQuoteModal && (
          <Modal
            title={"Create Quote"}
            handleSave={confirmCreateQuote}
            handleCancel={() => onCreateQuoteClick(false)}
            size={"lg"}
            sectionName={""}
            closeButtonText={"Cancel"}
            saveButtonText={"Create Quote"}
          >
            <>
              <div className="container-fluid p-2 border-0 m-0">
                <div className="search-form-container__fields">
                  <form className="search-form-container__fields__form">
                    {selectedProducts?.length != totalSelectableProducts && (
                      <div className="row align-items-center">
                        <div className="d-flex w-100 align-items-center justify-content-center">
                          <div className="alert alert-warning no-rooms-info mt-4" role="alert">
                            You have not selected all products. Please check that all materials, labor, and quantities
                            are correct.
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row align-items-center">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                        <InputField
                          type="text"
                          id="quoteName"
                          label="Quote Name"
                          placeholder={"Enter Quote Name"}
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={quoteName}
                          onChange={handleQuoteNameChange}
                          disabled={false}
                          isRequired={false}
                          errorMsg={quoteNameValid}
                        />
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                        <InputField
                          type="text"
                          id="accountName"
                          label="Account Name"
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={siteData.accountName ? siteData.accountName : "NA"}
                          onChange={(e) => true}
                          disabled={true}
                          isRequired={false}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                        <InputField
                          type="text"
                          id="accountNumber"
                          label={"Account Number"}
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={siteData.accountNumber ? siteData.accountNumber : "NA"}
                          onChange={(e) => true}
                          disabled={true}
                          isRequired={false}
                        />
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <StoreLookup
                        numberFieldChangeCallback={onStoreNumberChange}
                        nameFieldChangeCallback={onStoreNameChange}
                        onStoreLookupValidation={onStoreLookupValidation}
                        debounceValue={1000}
                        nameFieldWrapperClass="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group"
                        numberFieldWrapperClass="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group"
                        defaultData={defaultStoreData}
                        isEdit={true}
                        createQuoteFlag={true}
                      />

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                        <InputField
                          type="text"
                          id="territoryNumber"
                          label="Territory Number"
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={cookieFields.territoryNumber}
                          onChange={handleCookieFieldsChange}
                          disabled={false}
                          isRequired={false}
                          errorMsg={terrValid}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          </Modal>
        )}
      </div>
    </>
  );
};

export default SelectProducts;
